import React from 'react';

import { cn } from '@/lib/utils';

export interface UserAvatarProps {
  name: string;
  url?: string;
  icon?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-xs',
  lg: 'h-10 w-10 text-sm',
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  url,
  icon,
  size = 'md',
  className,
}) => {
  const sizeClass = sizeClasses[size];

  if (icon) {
    return (
      <div
        className={cn(
          sizeClass,
          'flex items-center justify-center rounded-full bg-gray-200 text-gray-600',
          className,
        )}
      >
        {icon}
      </div>
    );
  }

  if (url) {
    return (
      <img
        src={url}
        alt={name}
        className={cn(sizeClass, 'rounded-full object-cover', className)}
      />
    );
  }

  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div
      className={cn(
        sizeClass,
        'flex items-center justify-center rounded-full bg-gray-300 font-medium text-gray-700',
        className,
      )}
    >
      {initials}
    </div>
  );
};
